import { makePersisted } from "@solid-primitives/storage";
import { createSignal } from "solid-js";

export const [prefCurrency, setPrefCurrency] = makePersisted(createSignal("euro"), {
	name: "prefcurrency",
	deserialize: (v) => (v === "dollar" ? "dollar" : "euro"),
	serialize: (v) => v,
});
export function getCurrency() {
	switch (prefCurrency()) {
		case "dollar":
			return "$";
		default:
			return "€";
	}
}
